const zhChs = {
  'appManuals.downloadHelpText': '下载的文件可以通过互联网浏览器或PDF阅读器软件查看。',
  'appManuals.systemRequirements':
    '硬件要求 (推荐): Intel® Core™ i3或更高CPU, 4 GB或更多内存, 100 MB或更多自由存储空间用于PDF保存。',
  'appManuals.medicalsoftware.helptext': '国家可能会有不同的医疗软件。',
  '이미 등록된 라이선스가 있습니다.': '已存在已注册的许可证。',
  '갱신 가능한 기존 라이선스를 찾을 수 없습니다.': '未找到可续订的现有许可证。',
  '발급 가능한 잔여 수량이 없습니다.': '没有可发放的剩余数量。',
  // --- eIFU portal UI labels & language names (issue #16) ---
  'show all manuals': '显示所有手册',
  'This site complies with the General Data Protection Regulation (EU 2016/679).': '本网站符合《通用数据保护条例》(EU 2016/679)。',
  'This site meets the requirements of the General Data Protection Regulation (EU 2016/679).': '本网站满足《通用数据保护条例》(EU 2016/679)的要求。',
  'the content of this site is protected against unauthorized modification.': '本网站的内容受到保护，防止未经授权的修改。',
  'Previous versions of the User Manual are available for viewing and downloading via search.': '可通过搜索查看和下载用户手册的早期版本。',
  'Checking the latest documents.': '正在检查最新文档。',
  'There are no manuals to display.': '没有可显示的手册。',
  'Manuals': '手册',
  'Product Name': '产品名称',
  'Language': '语言',
  'Document Name': '文档名称',
  'Product': '产品',
  'Revision': '修订',
  'Document': '文档',
  'Published': '发布日期',
  'English': '英语',
  'Korean': '韩语',
  'Japanese': '日语',
  'German': '德语',
  'Russian': '俄语',
  'Chinese (Simplified)': '简体中文',
  'Chinese (Traditional)': '繁体中文',
  'Country': '国家',
  'eifuPortalIntro': '搜索并下载 RAY 医疗器械软件的电子使用说明书（eIFU）。',
  "criticalNotice.badge": "重要通知",
  "criticalNotice.close": "关闭",
};

export default zhChs;
